import React, { useState, useEffect, useCallback } from 'react';

const iconSvgs = {
  info: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>,
  warning: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  error: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>,
  success: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
};

const detectType = (message) => {
  const msg = (message || '').toLowerCase();
  if (msg.includes('hata') || msg.includes('error') || msg.includes('başarısız')) return 'error';
  if (msg.includes('başarı') || msg.includes('tamamlandı') || msg.includes('kopyalandı') || msg.includes('eklendi') || msg.includes('güncellen') || msg.includes('kaydedildi')) return 'success';
  return 'info';
};

const CustomDialog = () => {
  const [queue, setQueue] = useState([]);
  const current = queue[0] || null;

  const dismiss = useCallback((result) => {
    setQueue(q => {
      const [first, ...rest] = q;
      if (first?.resolve) first.resolve(result);
      return rest;
    });
  }, []);

  useEffect(() => {
    // Override window.alert (return value never used, safe)
    window.alert = (message) => {
      return new Promise(resolve => {
        setQueue(q => [...q, { type: 'alert', message: String(message), resolve }]);
      });
    };

    // Async confirm (call sites use: await window.showConfirm('msg'))
    window.showConfirm = (message) => {
      return new Promise(resolve => {
        setQueue(q => [...q, { type: 'confirm', message: String(message), resolve }]);
      });
    };
  }, []);

  useEffect(() => {
    if (!current) return;
    // V71 — capture fazında dinlenir: alttaki modal/sayfa ESC-Enter dinleyicileri tetiklenmez.
    // Odak diyalog düğmesindeyse Enter'ı düğme yönetir (İptal'de Enter "Onayla" sayılmasın, çift kapanma olmasın).
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        dismiss(current.type === 'confirm' ? false : undefined);
      } else if (e.key === 'Enter') {
        if (e.target?.closest?.('.custom-dialog-actions')) return;
        e.preventDefault();
        e.stopPropagation();
        dismiss(current.type === 'confirm' ? true : undefined);
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [current, dismiss]);

  if (!current) return null;

  const iconType = current.type === 'confirm' ? 'warning' : detectType(current.message);

  return (
    <div className="custom-dialog-overlay" onClick={() => dismiss(current.type === 'confirm' ? false : undefined)}>
      <div className="custom-dialog" onClick={e => e.stopPropagation()} role="alertdialog" aria-modal="true">
        <div className={`custom-dialog-icon ${iconType}`}>
          {iconSvgs[iconType]}
        </div>
        <div className="custom-dialog-title">
          {current.type === 'confirm' ? 'Onay' :
           iconType === 'error' ? 'Hata' :
           iconType === 'success' ? 'Başarılı' : 'Bilgi'}
        </div>
        <div className="custom-dialog-message">{current.message}</div>
        <div className="custom-dialog-actions">
          {current.type === 'confirm' ? (
            <>
              <button className="custom-dialog-btn" onClick={() => dismiss(false)}>İptal</button>
              <button className="custom-dialog-btn primary" onClick={() => dismiss(true)} autoFocus>Onayla</button>
            </>
          ) : (
            <button className="custom-dialog-btn primary" onClick={() => dismiss(undefined)} autoFocus>Tamam</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomDialog;
